/* eslint-disable */
/**
 * ForEach plan toggle-plan-monthly, toggle-plan-one-time, toggle-plan-annual, toggle-plan-educational
 *  get groups
 *      forEach group
 *          get features
 *              forEach feature
 *                  getFeatureName
 *                  getFeatureValues(4) [free, essential, plus, pro]
 */

// const simpleSlugify = (string) => {
//   return string.toLowerCase()
//     .replace(/[^\w ]+/g, '')
//     .replace(/ +/g, '-');
// }

// const featuresByPlan = {}
// // crawl features by plan info from https://ahaslides.com/pricing
// const crawlFeaturesByPlan = (plansIdentifier) => {
//   plansIdentifier.forEach((id) => {
//     const plan = document.querySelector(id)
//     const featureGroups = plan.querySelectorAll('.container.relative > div')
//     featureGroups.forEach((group) => {
//       const groupName = group.querySelector('.tc__header-title').innerText
//       const slugifiedGroupName = simpleSlugify(groupName)
//       const features = group.querySelectorAll('.tc__row--features')
//       features.forEach((feature) => {
//         const featureName = feature.querySelector('.tc__cell--feature-name > span').childNodes[0].textContent
//         const slugifiedFeatureName = simpleSlugify(featureName)
//         const featureValues = feature.querySelectorAll('.tc__svg')
//         const featureValue = Array.from(featureValues).map((svg) => {
//           if (svg.innerText.trim()) {
//             return svg.innerText
//           }
//           return svg.querySelectorAll('path').length === 1 // 1 = correct check mark, 2 == incorrect
//         })
//         const idMap = {
//           '#toggle-plan-monthly': 'monthly',
//           '#toggle-plan-one-time': 'one-time',
//           '#toggle-plan-annual': 'annual',
//           '#toggle-plan-educational': 'educational',
//         }
//         const idNew = idMap[id]
//         featuresByPlan[idNew] = featuresByPlan[idNew] || {}
//         featuresByPlan[idNew][slugifiedGroupName] = featuresByPlan[idNew][slugifiedGroupName] || {}
//         featuresByPlan[idNew][slugifiedGroupName][slugifiedFeatureName] = featureValue // [free, essential, plus, pro]
//       })
//     })
//   })
// }
// const ids = ['#toggle-plan-monthly', '#toggle-plan-one-time', '#toggle-plan-annual', '#toggle-plan-educational']
// crawlFeaturesByPlan(ids)

const featuresByPlan = {
  annual: {
    updateLink: [
      {
        url: '/apps/presentations?source=pricing&medium=landing_site&campaign=landing_site&content=free_annually',
        permissionKey: 'free'
      },
      {
        url: '/apps/upgrade/essential-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=essential_annually',
        permissionKey: 'essentialYearly'
      },
      {
        url: '/apps/upgrade/plus-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=plus_annually',
        permissionKey: 'plusYearly'
      },
      {
        url: '/apps/upgrade/pro-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=pro_annually',
        permissionKey: 'proYearly'
      },
    ],
    planPrices: [
      {
        label: 'Free',
        price: 0,
        'smaller-price': 0,
        unit: 'month',
      },
      {
        label: 'Essential',
        price: 7,
        'smaller-price': 95,
        unit: 'month',
      },
      {
        label: 'Plus',
        price: 10,
        'smaller-price': 95,
        unit: 'month',
      },
      {
        label: 'Pro',
        price: 15,
        'smaller-price': 95,
        unit: 'month',
      },
    ],
    plansDropdown: [
      { plan: 'monthly', title: 'Monthly plans' },
      { plan: 'educational', title: 'Educational plans' },
    ],
    participation: {
      'max-participants': {
        title: 'Max. participants',
        tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
        planVal: ['7', '50', '200', '10,000'],
      },
      'custom-link': {
        title: 'Custom link',
        tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
        planVal: [true, true, true, true],
      },
      'qr-code': {
        title: 'QR code',
        tooltipVal: 'Have an unique QR code to include on your slides, printouts, event tickets..',
        planVal: [true, true, true, true],
      },
      'audience-authentication': {
        title: 'Audience authentication',
        tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
        planVal: [false, false, false, true],
      },
      'video-call': {
        title: 'Video call',
        tooltipVal: 'Video call any participant and show the conversation on your screen.',
        planVal: [false, false, false, true],
      },
    },
    data: {
      'data-exports': {
        title: 'Data exports',
        tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
        planVal: [false, true, true, true],
      },
      'pdf-jpg-exports': {
        title: 'PDF / JPG exports',
        tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
        planVal: [false, true, true, true],
      },
    },
    customisation: {
      'custom-logo': {
        title: 'Custom logo',
        tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
        planVal: [false, false, false, true],
      },
      'designer-fonts': {
        title: 'Designer fonts',
        tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
        planVal: [true, true, true, true],
      },
      'custom-backgrounds': {
        title: 'Custom backgrounds',
        tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
        planVal: [true, true, true, true],
      },
      'audio-tracks': {
        title: 'Audio tracks',
        tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
        planVal: [false, true, true, true],
      },
    },
    presentation: {
      'collaborative-editing': {
        title: 'Collaborative editing',
        tooltipVal: 'Let your friends and colleagues edit your presentations with you',
        planVal: [true, true, true, true],
      },
      'unlimited-polls': {
        title: 'Unlimited polls',
        tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended questions',
        planVal: [true, true, true, true],
      },
      'unlimited-word-clouds': {
        title: 'Unlimited Word Clouds',
        tooltipVal: 'Word Cloud (also known as Wordle or Tag Cloud) gives you an elegant visual representation of keywords, and is great for brainstorming',
        planVal: [true, true, true, true],
      },
      'unlimited-qa': {
        title: 'Unlimited Q&A',
        tooltipVal: 'Crowdsource the best questions from your audience',
        planVal: [true, true, true, true],
      },
      'unlimited-quiz': {
        title: 'Unlimited Quiz',
        tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
        planVal: [true, true, true, true],
      },
      brainstorming: {
        title: 'Brainstorming',
        tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
        planVal: [true, true, true, true],
      },
      'spinner-wheel': {
        title: 'Spinner Wheel',
        tooltipVal: 'Fun way to randomly pick a winner or an idea',
        planVal: [true, true, true, true],
      },
      'multilanguage-support': {
        title: 'Multilanguage support',
        tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
        planVal: [true, true, true, true],
      },
      'powerpoint-pdf-import': {
        title: 'PowerPoint / PDF import',
        tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
        planVal: [true, true, true, true],
      },
    },
  },
  monthly: {
    updateLink: [
      {
        url: '/apps/presentations?source=pricing&medium=landing_site&campaign=landing_site&content=free_monthly',
        permissionKey: 'free',
      },
      {
        url: '/apps/upgrade/essential-monthly?source=pricing&medium=landing_site&campaign=landing_site&content=essential_monthly',
        permissionKey: 'essentialMonthly',
      },
      {
        url: '/apps/upgrade/plus-monthly?source=pricing&medium=landing_site&campaign=landing_site&content=plus_monthly',
        permissionKey: 'plusMonthly',
      },
      {
        url: '/apps/upgrade/pro-monthly?source=pricing&medium=landing_site&campaign=landing_site&content=pro_monthly',
        permissionKey: 'proMonthly',
      },
    ],
    planPrices: [
      {
        label: 'Free',
        price: 0,
        'smaller-price': 0,
        unit: 'month',
      },
      {
        label: 'Essential',
        price: 23,
        'smaller-price': 95,
        unit: 'month',
      },
      {
        label: 'Plus',
        price: 32,
        'smaller-price': 95,
        unit: 'month',
      },
      {
        label: 'Pro',
        price: 49,
        'smaller-price': 95,
        unit: 'month',
      },
    ],
    plansDropdown: [
      { plan: 'annual', title: 'Annual plans' },
      { plan: 'educational', title: 'Educational plans' },
    ],
    participation: {
      'max-participants': {
        title: 'Max. participants',
        tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
        planVal: ['7', '50', '200', '10,000'],
      },
      'custom-link': {
        title: 'Custom link',
        tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
        planVal: [true, true, true, true],
      },
      'qr-code': {
        title: 'QR code',
        tooltipVal: 'Have an unique QR code to include on your slides, printouts, event tickets..',
        planVal: [true, true, true, true],
      },
      'audience-authentication': {
        title: 'Audience authentication',
        tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
        planVal: [false, false, false, true],
      },
      'video-call': {
        title: 'Video call',
        tooltipVal: 'Video call any participant and show the conversation on your screen.',
        planVal: [false, false, false, true],
      },
    },
    data: {
      'data-exports': {
        title: 'Data exports',
        tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
        planVal: [false, true, true, true],
      },
      'pdf-jpg-exports': {
        title: 'PDF / JPG exports',
        tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
        planVal: [false, true, true, true],
      },
    },
    customisation: {
      'custom-logo': {
        title: 'Custom logo',
        tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
        planVal: [false, false, false, true],
      },
      'designer-fonts': {
        title: 'Designer fonts',
        tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
        planVal: [true, true, true, true],
      },
      'custom-backgrounds': {
        title: 'Custom backgrounds',
        tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
        planVal: [true, true, true, true],
      },
      'audio-tracks': {
        title: 'Audio tracks',
        tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
        planVal: [false, true, true, true],
      },
    },
    presentation: {
      'collaborative-editing': {
        title: 'Collaborative editing',
        tooltipVal: 'Let your friends and colleagues edit your presentations with you',
        planVal: [true, true, true, true],
      },
      'unlimited-polls': {
        title: 'Unlimited polls',
        tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended questions',
        planVal: [true, true, true, true],
      },
      'unlimited-word-clouds': {
        title: 'Unlimited Word Clouds',
        tooltipVal: 'Word Cloud (also known as Wordle or Tag Cloud) gives you an elegant visual representation of keywords, and is great for brainstorming',
        planVal: [true, true, true, true],
      },
      'unlimited-qa': {
        title: 'Unlimited Q&A',
        tooltipVal: 'Crowdsource the best questions from your audience',
        planVal: [true, true, true, true],
      },
      'unlimited-quiz': {
        title: 'Unlimited Quiz',
        tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
        planVal: [true, true, true, true],
      },
      brainstorming: {
        title: 'Brainstorming',
        tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
        planVal: [true, true, true, true],
      },
      'spinner-wheel': {
        title: 'Spinner Wheel',
        tooltipVal: 'Fun way to randomly pick a winner or an idea',
        planVal: [true, true, true, true],
      },
      'multilanguage-support': {
        title: 'Multilanguage support',
        tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
        planVal: [true, true, true, true],
      },
      'powerpoint-pdf-import': {
        title: 'PowerPoint / PDF import',
        tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
        planVal: [true, true, true, true],
      },
    },
  },
  'one-time': {
    updateLink: [
      {
        url: '/apps/upgrade/one-time-mini?source=pricing&medium=landing_site&campaign=landing_site&content=one_time_mini',
        permissionKey: 'oneTimeMini',
      },
      {
        url: '/apps/upgrade/one-time-small?source=pricing&medium=landing_site&campaign=landing_site&content=one_time_small',
        permissionKey: 'oneTimeSmall',
      },
      {
        url: '/apps/upgrade/one-time-medium?source=pricing&medium=landing_site&campaign=landing_site&content=one_time_medium',
        permissionKey: 'oneTimeMedium',
      },
      {
        url: '/apps/upgrade/one-time-large?source=pricing&medium=landing_site&campaign=landing_site&content=one_time_large',
        permissionKey: 'oneTimeLarge',
      },
    ],
    planPrices: [
      {
        label: 'Mini',
        price: 4,
        'smaller-price': 95,
        unit: 'event',
      },
      {
        label: 'Small',
        price: 10,
        'smaller-price': 95,
        unit: 'event',
      },
      {
        label: 'Medium',
        price: 26,
        'smaller-price': 95,
        unit: 'event',
      },
      {
        label: 'Large',
        price: 35,
        'smaller-price': 95,
        unit: 'event',
      },
    ],
    plansDropdown: [
      { plan: 'monthly', title: 'Monthly plans' },
      { plan: 'annual', title: 'Annual plans' },
      { plan: 'educational', title: 'Educational plans' },
    ],
    participation: { // [mini, small, medium, large]
      'max-participants': {
        title: 'Max. participants',
        tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
        planVal: ['15', '30', '100', '1,000'],
      },
      'custom-link': {
        title: 'Custom link',
        tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
        planVal: [true, true, true, true],
      },
      'qr-code': {
        title: 'QR code',
        tooltipVal: 'Have an unique QR code to include on your slides, printouts, event tickets..',
        planVal: [true, true, true, true],
      },
      'audience-authentication': {
        title: 'Audience authentication',
        tooltipVal: 'Participants must enter the unique codes you provide, to be able to join the presentation.',
        planVal: [false, false, false, true],
      },
      'video-call': {
        title: 'Video call',
        tooltipVal: 'Video call any participant and show the conversation on your screen.',
        planVal: [false, false, false, true],
      },
    },
    data: {
      'data-exports': {
        title: 'Data exports',
        tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
        planVal: [true, true, true, true],
      },
      'pdf-jpg-exports': {
        title: 'PDF / JPG exports',
        tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
        planVal: [true, true, true, true],
      },
    },
    customisation: {
      'custom-logo': {
        title: 'Custom logo',
        tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
        planVal: [false, false, false, false],
      },
      'designer-fonts': {
        title: 'Designer fonts',
        tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
        planVal: [true, true, true, true],
      },
      'custom-backgrounds': {
        title: 'Custom backgrounds',
        tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
        planVal: [true, true, true, true],
      },
      'audio-tracks': {
        title: 'Audio tracks',
        tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
        planVal: [true, true, true, true],
      },
    },
    presentation: {
      'collaborative-editing': {
        title: 'Collaborative editing',
        tooltipVal: 'Let your friends and colleagues edit your presentations with you',
        planVal: [true, true, true, true],
      },
      'unlimited-polls': {
        title: 'Unlimited polls',
        tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended questions',
        planVal: [true, true, true, true],
      },
      'unlimited-word-clouds': {
        title: 'Unlimited Word Clouds',
        tooltipVal: 'Word Cloud (also known as Wordle or Tag Cloud) gives you an elegant visual representation of keywords, and is great for brainstorming',
        planVal: [true, true, true, true],
      },
      'unlimited-qa': {
        title: 'Unlimited Q&A',
        tooltipVal: 'Crowdsource the best questions from your audience',
        planVal: [true, true, true, true],
      },
      'unlimited-quiz': {
        title: 'Unlimited Quiz',
        tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
        planVal: [true, true, true, true],
      },
      brainstorming: {
        title: 'Brainstorming',
        tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
        planVal: [true, true, true, true],
      },
      'spinner-wheel': {
        title: 'Spinner Wheel',
        tooltipVal: 'Fun way to randomly pick a winner or an idea',
        planVal: [true, true, true, true],
      },
      'multilanguage-support': {
        title: 'Multilanguage support',
        tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
        planVal: [true, true, true, true],
      },
      'powerpoint-pdf-import': {
        title: 'PowerPoint / PDF import',
        tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
        planVal: [true, true, true, true],
      },
    },
  },
  educational: {
    updateLink: [
      {
        url: '/apps/presentations?source=pricing&medium=landing_site&campaign=landing_site&content=free_edu',
        permissionKey: 'free',
      },
      {
        url: '/apps/upgrade/edu-small-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=edu_small',
        permissionKey: 'eduSmallYearly',
      },
      {
        url: '/apps/upgrade/edu-medium-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=edu_medium',
        permissionKey: 'eduMediumYearly',
      },
      {
        url: '/apps/upgrade/edu-large-yearly?source=pricing&medium=landing_site&campaign=landing_site&content=edu_large',
        permissionKey: 'eduLargeYearly',
      },
    ],
    planPrices: [
      {
        label: 'Free',
        price: 0,
        'smaller-price': 0,
        unit: 'month',
      },
      {
        label: 'Edu Small',
        price: 2,
        'smaller-price': 95,
        unit: 'month',
      },
      {
        label: 'Edu Medium',
        price: 5,
        'smaller-price': 45,
        unit: 'month',
      },
      {
        label: 'Edu Large',
        price: 7,
        'smaller-price': 65,
        unit: 'month',
      },
    ],
    plansDropdown: [
      { plan: 'monthly', title: 'Monthly plans' },
      { plan: 'annual', title: 'Annual plans' },
    ],
    participation: {
      'max-participants': {
        title: 'Max. participants',
        tooltipVal: 'Maximum number of live participants that can join your presentation at the same time',
        planVal: ['7', '25', '50', '200'],
      },
      'custom-link': {
        title: 'Custom link',
        tooltipVal: 'Set a short, memorable link for your presentation, so that your participants can easily join in',
        planVal: [true, true, true, true],
      },
      'qr-code': {
        title: 'QR code',
        tooltipVal: 'Have an unique QR code to include on your slides, printouts, event tickets..',
        planVal: [true, true, true, true],
      },
    },
    data: {
      'data-exports': {
        title: 'Data exports',
        tooltipVal: 'Export full data from your presentation, including all audience data and responses, to Excel files for deeper analysis',
        planVal: [false, true, true, true],
      },
      'pdf-jpg-exports': {
        title: 'PDF / JPG exports',
        tooltipVal: 'Export your slides, including audience responses, into a PDF document, or a set of JPG images',
        planVal: [false, true, true, true],
      },
    },
    customisation: {
      'custom-logo': {
        title: 'Custom logo',
        tooltipVal: 'You can add your own logo (to replace default AhaSlides logo) on your slides and on your audience\'s phone screen',
        planVal: [false, false, false, false],
      },
      'designer-fonts': {
        title: 'Designer fonts',
        tooltipVal: 'Have access to a range of beautiful designer fonts (including special fonts for Arabic and Thai)',
        planVal: [true, true, true, true],
      },
      'custom-backgrounds': {
        title: 'Custom backgrounds',
        tooltipVal: 'Change text colour, background colour and background images to make your slides truly yours',
        planVal: [true, true, true, true],
      },
      'audio-tracks': {
        title: 'Audio tracks',
        tooltipVal: 'Add audio tracks that are playable by both the presenter and the audience on any slide',
        planVal: [false, true, true, true],
      },
    },
    presentation: {
      'collaborative-editing': {
        title: 'Collaborative editing',
        tooltipVal: 'Let your friends and colleagues edit your presentations with you',
        planVal: [true, true, true, true],
      },
      'unlimited-polls': {
        title: 'Unlimited polls',
        tooltipVal: 'Including Multiple Choice, Image Choice, Open Ended questions',
        planVal: [true, true, true, true],
      },
      'unlimited-word-clouds': {
        title: 'Unlimited Word Clouds',
        tooltipVal: 'Word Cloud (also known as Wordle or Tag Cloud) gives you an elegant visual representation of keywords, and is great for brainstorming',
        planVal: [true, true, true, true],
      },
      'unlimited-qa': {
        title: 'Unlimited Q&A',
        tooltipVal: 'Crowdsource the best questions from your audience',
        planVal: [true, true, true, true],
      },
      'unlimited-quiz': {
        title: 'Unlimited Quiz',
        tooltipVal: 'Add fun (or competitive) Quiz games to your presentation to make it even more engaging',
        planVal: [true, true, true, true],
      },
      brainstorming: {
        title: 'Brainstorming',
        tooltipVal: 'Let everyone submit their ideas and vote for their favourite',
        planVal: [true, true, true, true],
      },
      'spinner-wheel': {
        title: 'Spinner Wheel',
        tooltipVal: 'Fun way to randomly pick a winner or an idea',
        planVal: [true, true, true, true],
      },
      'multilanguage-support': {
        title: 'Multilanguage support',
        tooltipVal: 'English, Deutsch, Español, Français, Italiano, 日本語, Nederlands, Português, Türkçe, Tiếng Việt',
        planVal: [true, true, true, true],
      },
      'powerpoint-pdf-import': {
        title: 'PowerPoint / PDF import',
        tooltipVal: 'Import your existing PPT, PPTX, and PDF presentation files to your AhaSlides presentation',
        planVal: [true, true, true, true],
      },
    },
  },
};
export default featuresByPlan
